import { render, staticRenderFns } from "./SiteMonitorHeader.vue?vue&type=template&id=8b2fd820&scoped=true"
import script from "./SiteMonitorHeader.vue?vue&type=script&lang=ts"
export * from "./SiteMonitorHeader.vue?vue&type=script&lang=ts"
import style0 from "./SiteMonitorHeader.vue?vue&type=style&index=0&id=8b2fd820&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2fd820",
  null
  
)

export default component.exports